<template>

  <div class="layout-wrapper">

    <!-- HERO -->
    <section
      ref="hero"
      class="hero-section d-flex align-items-center"
      :style="heroStyle"
    >

     <img
              v-if="header?.logo"
              src="https://gestionaleimmagini.s3.eu-central-1.amazonaws.com/fredericmalle26/bg_3.png"
              width="100%"
             class="mobile"
            >

      <div class="container position-relative text-center desktop" >

        <!-- NAVBAR -->

          <div class="container-fluid">

            <img
              v-if="header?.logo"
              :src="header.logo"
              width="100%"
              class="me-3"
            >

          </div>

        <!-- HERO TEXT -->

      </div>

    </section>

    <!-- MAIN -->

    <section class="main-content bg-light" style="text-align: center!important;">

      <div class="container content-wrapper" style="margin-top:20px">

        <div class="status-icon-box">
        <div class="red-circle">
          <span class="check-v">✓</span>
        </div>
      </div>

      <h1 class="main-thank-you-title">
        REGISTRAZIONE AVVENUTA<br />
        CON SUCCESSO
      </h1>

      <div class="copy-section">
        <p class="primary-msg">
          Grazie per esserti registrato.<br />
          Il tuo appuntamento è stato correttamente salvato.
        </p>

        <p class="secondary-msg">
          Riceverai a breve una mail di conferma con il<br />
          riepilogo del tuo appuntamento.
        </p>
      </div>

      <p class="final-cta">
        TI ASPETTIAMO IN BOUTIQUE!
      </p>

      </div>

    </section>

  </div>

</template>

<script>
export default {
  name: 'ThankYouPage',
  props: ['pages', 'header'],
  data () {
    return {
      heroGlowColor: 'rgba(0,0,0,0.5)',
      heroTextColor: '#ffffff',
      heroTextShadow: '0 2px 10px rgba(0,0,0,0.9)'
    }
  },

  computed: {

    heroStyle () {
      return {

        background: this.theme?.backgroundImage ? `url(${this.theme.backgroundImage}) center/cover no-repeat` : `background-color(${this.theme?.primaryColor} || '#ce4135')`, position: 'relative'
      }
    },

    textStyle () {
      return {
        color: this.heroTextColor,
        textShadow: this.heroTextShadow
      }
    }

  },

  methods: {

    extractDominantColor () {
      if (!this.theme?.backgroundImage) return

      const img = new Image()
      img.crossOrigin = 'Anonymous'
      // img.src = this.theme.backgroundImage
      const apiBase = process.env.VUE_APP_API
      const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      img.src = apiBase + '/proxy-image.php?url=' + encodeURIComponent(this.theme.backgroundImage) + '&controllo=' + session

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data
        let r = 0; let g = 0; let b = 0; let count = 0
        for (let i = 0; i < data.length; i += 40) {
          r += data[i]
          g += data[i + 1]
          b += data[i + 2]
          count++
        }
        r = Math.floor(r / count)
        g = Math.floor(g / count)
        b = Math.floor(b / count)
        this.heroGlowColor = `rgba(${r},${g},${b},0.6)`
        this.heroTextColor = `rgba(${r},${g},${b},1)`
      }
    }

  },

  watch: {

    'theme.backgroundImage': {
      immediate: true,
      handler () {
        this.extractDominantColor()
      }
    }

  }
}

</script>

<style scoped>
.thankyou-page-wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 0;
  padding: 0;
  font-family: 'FMHelvetica', Helvetica, Arial, sans-serif;
}

/* HEADER ROSSO: Qui sta la magia. Va a 100% della larghezza finestra */
.hero-red-header {
  width: 100%;
  background-color: #da291c; /* Rosso Malle */
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-inner {
  width: 100%;
  max-width: 1000px; /* Allineato all'immagine del form */
  text-align: center;
}

.header-logo-img {
  max-width: 100%;
  height: auto;
  max-height: 120px;
  display: block;
  margin: 0 auto;
}

/* CORPO DELLA PAGINA: Centrato e con i giusti spazi bianchi */
.content-body {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
}

.status-icon-box {
  margin-bottom: 40px;
}

.red-circle {
  width: 75px;
  height: 75px;
  background-color: #da291c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.check-v {
  color: #fff;
  font-size: 40px;
  line-height: 1;
}

.main-thank-you-title {
  font-size: 26px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.2;
  margin-bottom: 50px;
  color: #000;
}

.copy-section {
  margin-bottom: 60px;
}

.primary-msg {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 25px;
  color: #000;
}

.secondary-msg {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
}

.final-cta {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 16px;
  letter-spacing: 2px;
  color: #000;
  margin-top: 40px;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-red-header {
    padding: 30px 15px;
  }
  .main-thank-you-title {
    font-size: 22px;
  }
  .content-body {
    padding: 40px 20px;
  }
}

.mobile {
  display: none;
}

.desktop{
  display: block;
}

@media (max-width: 576px) {

  .mobile {
  display:  block;
}

.desktop{
  display: none;
}

  /* 1) elimina padding laterale bootstrap nella hero */
  .hero-section .container,
  .hero-section .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* 2) elimina margini dell'immagine (me-3 ecc.) */
  .hero-section img {
    display: block;
    margin: 0 !important;
  }

  /* 3) forza il full-bleed anche se rimane dentro un container */
  .hero-section .container-fluid {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  /* immagine a tutta larghezza della viewport */
  .hero-section .container-fluid img {
    width: 100% !important;
    height: auto;
  }

  .content-wrapper{
    padding-left: 30px;
    padding-right: 30px;
    background-color: #fff;

  }

  /* evita eventuale scroll orizzontale dovuto al 100vw */
  .layout-wrapper {
    overflow-x: hidden;

  }
}

.layout-wrapper{

  display:flex;

  flex-direction:column;

  min-height:100vh;

}

.hero-section{

  position:relative;

}

.overlay{

  position:absolute;

  inset:0;

  background:rgba(0,0,0,0.35);

}

.main-content{

  flex:1;

}

.footer{

  margin-top:auto;

}

.mobile {
  display: none;
}

.desktop{
  display: block;
}

@media (max-width: 576px) {

  .mobile {
  display:  block;
}

.desktop{
  display: none;
}

  /* 1) elimina padding laterale bootstrap nella hero */
  .hero-section .container,
  .hero-section .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* 2) elimina margini dell'immagine (me-3 ecc.) */
  .hero-section img {
    display: block;
    margin: 0 !important;
  }

  /* 3) forza il full-bleed anche se rimane dentro un container */
  .hero-section .container-fluid {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  /* immagine a tutta larghezza della viewport */
  .hero-section .container-fluid img {
    width: 100% !important;
    height: auto;
  }

  .content-wrapper{
    padding-left: 30px;
    padding-right: 30px;
    background-color: #fff;

  }

  /* evita eventuale scroll orizzontale dovuto al 100vw */
  .layout-wrapper {
    overflow-x: hidden;

  }
}
</style>
